<div class="disconnected-sale-product display-utils-col display-utils-flex-100">
    <div class="header display-utils-row display-utils-hide-lt-md" [ngClass]="{'display-utils-show-lt-md': showDetail || this.firstStep}">
        <p class="header-text">Você está adquirindo</p>
    </div>

    <!--DETALHES DO PRODUTO-->
    <div class="product-info display-utils-row">
        <div class="display-utils-row display-utils-start-center">
            <div class="product-image display-utils-center-center">
                <img src={{this.productImg}} alt="icone-{{this.productFamily}}" />
            </div>
            <div class="product-details display-utils-col">
                <p class="product-solution display-utils-only-gt-sm">Solução <b class="highlight">Pré-Pago</b></p>
                <p class="product-family">{{this.productFamily}}</p>
                <p class="product-name">{{this.productName}}</p>
            </div>
        </div>
        <div class="dropDown display-utils-hide-gt-sm" [ngClass]="{'display-utils-hide-lt-md': firstStep}">
            <button class="btn-toogle-dropdown" (click)="clickDropdown()"><img src="/assets/images/drop-down-icon.png"
                    [ngClass]="{'rotate': showDetail}" /></button>
        </div>
    </div>

    <!--MENSAGEM DE ENVIO DE EMAIL-->
    <div class="footer display-utils-row display-utils-start-center display-utils-gap-8 display-utils-hide-lt-md" [ngClass]="{'display-utils-show-lt-md': showDetail || firstStep}">
        <div class="footer-icon">
            <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.3333 11.3334H1.66667C1.31304 11.3334 0.973905 11.1929 0.723856 10.9428C0.473808 10.6928 0.333332 10.3536 0.333332 10L0.339999 2.00002C0.339994 1.64755 0.479555 1.30942 0.728163 1.05956C0.976772 0.809703 1.3142 0.668449 1.66667 0.666687H12.3333C12.687 0.666687 13.0261 0.807163 13.2761 1.05721C13.5262 1.30726 13.6667 1.6464 13.6667 2.00002V10C13.6667 10.3536 13.5262 10.6928 13.2761 10.9428C13.0261 11.1929 12.687 11.3334 12.3333 11.3334ZM1.66667 3.33335V9.33335C1.66667 9.51016 1.7369 9.67973 1.86193 9.80476C1.98695 9.92978 2.15652 10 2.33333 10H11.6667C11.8435 10 12.013 9.92978 12.1381 9.80476C12.2631 9.67973 12.3333 9.51016 12.3333 9.33335V3.33335L7.70667 6.22669C7.4952 6.36034 7.25016 6.43129 7 6.43129C6.74983 6.43129 6.5048 6.36034 6.29333 6.22669L1.66667 3.33335ZM1.66667 2.00002L7 5.33335L12.3333 2.00002H1.66667Z"
                    fill="#77127B" />
            </svg>
        </div>
        <p class="footer-text" [ngClass]="{'display-utils-hide-lt-md': !(showDetail || firstStep)}">
            Após o pagamento, você <b>receberá um e-mail</b> para validar seus dados.
        </p>
    </div>

    <!--DESCONTO-->
    <hr [ngClass]="{'display-utils-hide-gt-sm': (this.firstStep && this.discountedValue === '0,00'), 'display-utils-hide-lt-md': (!this.firstStep && !this.showDetail) || (this.firstStep && this.discountedValue === '0,00')}">

    <div class="discounts" [ngClass]="{'display-utils-hide-gt-sm': (this.firstStep && this.discountedValue === '0,00'), 'display-utils-hide-lt-md': (!this.firstStep && !this.showDetail) || (this.firstStep && this.discountedValue === '0,00')}">
        <pme-disconnected-sale-discount-form
            *ngIf="this.cart && (this.currentDisconnetedSaleStep === this.disconnetedSaleStepEnum.PAYMENT && !this.isCheckoutSuccessfull)"
            [cart]="this.cart" (productUpdateEmit)="this.updateProduct($event)"
            (cartUpdated)="this.handleCartUpdate($event)">
        </pme-disconnected-sale-discount-form>
        <div class="discounts-info">
            <div class="discountLine display-utils-row display-utils-between-center">
                <p>
                    Subtotal
                </p>
                <p>
                    R$ {{this.productValue}}
                </p>
            </div>
            <div class="discountLine display-utils-row display-utils-between-center"
                *ngIf="this.discountedValue && this.discountedValue !== '0,00'">
                <p>
                    Desconto
                </p>
                <b>
                    -R$ {{this.discountedValue}}
                </b>
            </div>
        </div>
    </div>

    <!--TOTAL A PAGAR-->
    <hr class="display-utils-hide-lt-md" [ngClass]="{'display-utils-show-lt-md': showDetail || this.firstStep}">

    <div class="total display-utils-hide-lt-md" [ngClass]="{'display-utils-show-lt-md': showDetail || this.firstStep}">
        <div class="totalLine display-utils-row display-utils-between-center">
            <p>
                Total a pagar
            </p>
            <p>
                <span *ngIf="this.installments && this.installments > 1">
                    {{this.installments}}x de
                </span>
                <b>
                    R$ {{this.valuePerMonth}}
                </b>
            </p>
        </div>
    </div>

</div>
